import { render, staticRenderFns } from "./BaseTimepicker.vue?vue&type=template&id=c8b17f0a&"
import script from "./BaseTimepicker.vue?vue&type=script&lang=ts&"
export * from "./BaseTimepicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VTimePicker})
